<!-- eslint-disable -->
<template>
  <v-card height="100%" v-if="resource">
    <v-expansion-panels multiple v-model="panel">
      <panel-resource />
      <template v-if="$route.params.id">
        <panel-files />
        <panel-mannto />
      </template>
    </v-expansion-panels>
    <v-card-actions v-if="$route.params.id">
      <v-btn color="primary" @click="$router.push({ name: 'vehicles' })">
        regresar a vehiculos
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PanelResource from "./PanelResource.vue";
import PanelFiles from "./PanelFiles.vue";
import PanelMannto from "./PanelMannto.vue";
export default {
  name: "Show",
  components: { PanelResource, PanelFiles, PanelMannto },
  computed: {
    ...mapState({
      resource: state => state.Vehicles.resource
    }),
    panel: {
      get: function() {
        return this.$store.state.Vehicles.panel;
      },
      set: function(val) {
        this.$store.commit("Vehicles/setPanel", val);
      }
    }
  },
  methods: {
    ...mapActions("Vehicles", ["nuevo", "getResource"])
  },
  beforeMount() {
    if (!this.resource) {
      if (this.$route.params.id) {
        this.getResource(this.$route.params.id);
      } else {
        this.nuevo();
      }
    }
  }
};
</script>
